import defaultBotAvatar from "@/assets/ChatGPT/bot.png";
import defaultUserAvatar from "@/assets/ChatGPT/user.png";

import {
  newConversation,
  sendMessage,
  getMessage as getMessageHistory,
  webSocketClient,
  getConversationStatus,
  uploadConversationAttachment,
} from "@/api";
import {
  MessageSourceType,
  MessageModel,
  BubbleMessage,
} from "./message-model";
import { formatTime } from "@/utils/timeUtil.js";

export default {
  name: "AiLogicMixin",
  emits: ["scroll-to-bottom", "destroyed", "isLoading"],
  data() {
    return {
      inputValue: "",
      bubbleList: [], // 气泡列表
      fileList: [],
      conversation: null,
      timer: null,
      receiveMessageTimer: 0,
      checkConversationTimer: 0,
      checkConversationTimerTimes: 0,
      _httpRemedyTimer: 0,
      isWorkflow: false,
      stompClient: null,
      sending: false,
      _agentId: null,
      agentInfo: null,
      promptPara: {},
      agentEvent: null,
      messageList: [], // 全局消息列表
    };
  },
  computed: {
    currentConversationId() {
      return this.conversation && this.conversation.conversationId;
    },
    websocketId() {
      return this.conversation && this.conversation.websocketId;
    },
  },
  methods: {
    /**
     * 统一处理所有新消息（历史/实时）
     * @param {Object} msg 消息对象
     * @returns {MessageModel}
     */
    processIncomingMessage(msg) {
      // 统一处理 loadHistory 和 stompMessage 格式
      // 提取 content
      let content = "";
      if (msg.message && typeof msg.message.content === "string") {
        content = msg.message.content;
      } else if (typeof msg.content === "string") {
        content = msg.content;
      } else if (msg.message && typeof msg.message.content === "object" && msg.message.content.message && typeof msg.message.content.message.content === "string") {
        content = msg.message.content.message.content;
      }
      // 提取 sourceType
      let sourceType = msg.sourceType || (msg.source === "User" ? MessageSourceType.USER : MessageSourceType.AI);
      // 提取 isCompleted
      let isCompleted = !!msg.isCompleted;
      // 提取 timestamp
      const timestamp = msg.timestamp ? Number(msg.timestamp) : Date.now();
      // 提取 avatarUrl
      const avatarUrl = msg.avatarUrl || (sourceType === MessageSourceType.USER ? defaultUserAvatar : (this.agentInfo && this.agentInfo.avatar_url) || defaultBotAvatar);
      // 构造 MessageModel
      const messageModel = new MessageModel({
        ...msg,
        content,
        sourceType,
        isCompleted,
        timestamp,
        avatarUrl,
      });
      this.messageList.push(messageModel);

      // 气泡分组逻辑：isCompleted 且 messageType 与上一条不同则新建气泡，否则追加
      let lastBubble = this.getLastBubble();
      let needNewBubble = false;
      if (!lastBubble) {
        needNewBubble = true;
      } else {
        const lastMsg = lastBubble.messageList[lastBubble.messageList.length - 1];
        const lastType = lastMsg && lastMsg.message && lastMsg.message.type;
        const currType = messageModel.message && messageModel.message.type;
        if (isCompleted && lastBubble.sourceType === sourceType && lastType !== currType) {
          needNewBubble = true;
        } else if (lastBubble.sourceType !== sourceType) {
          needNewBubble = true;
        }
      }
      if (needNewBubble) {
        const bubble = new BubbleMessage({
          sourceType,
          timestamp,
          avatarUrl,
          files: messageModel.files || [],
          tool_interactions: messageModel.tool_interactions || [],
        });
        bubble.addOrUpdateMessage(messageModel);
        this.bubbleList.push(bubble);
        lastBubble = bubble;
      } else {
        lastBubble.messageList.push(messageModel);
      }
      // 补充气泡属性
      if (messageModel.files) lastBubble.files = messageModel.files;
      if (messageModel.tool_interactions) lastBubble.tool_interactions = messageModel.tool_interactions;
      if (avatarUrl) lastBubble.avatarUrl = avatarUrl;
      // if (isCompleted) {
      //   console.log("bubbleList:", this.bubbleList);
      //   console.log("messageList:", this.messageList);
      // }
      this.$emit("scroll-to-bottom");
    },
    /**
     * 清除计时器
     */
    clearTimer() {
      const me = this;
      clearInterval(me.timer);
      me.timer = null;
    },
    async initConversation() {
      const me = this;
      me.$emit("isLoading", true);
      try {
        const agentId = me._agentId;
        if (agentId === undefined || agentId === null) {
          me.$message.error("Agent ID is required");
          return;
        }
        const result = await newConversation([agentId], me.promptPara);
        me.$emit("isLoading", false);
        me.conversation = result.conversation;
        me.$emit("init-conversation", me.conversation);
        console.log("new conversation id", me.currentConversationId);
      } catch (error) {
        me.$emit("isLoading", false);
        me.$message.error("Error");
      }
    },
    async uploadAttachment(conversationId) {
      for (const fileModel of this.fileList) {
        if (fileModel.file) {
          await uploadConversationAttachment(conversationId, fileModel.file);
        }
      }
    },
    async handleSendMessage(message) {
      const me = this;
      let msgObj;
      if (typeof message === "string") {
        msgObj = {
          message: { content: message, type: "text" },
          source: "User",
        };
      } else {
        msgObj = message;
      }
      msgObj.files = this.fileList.slice();
      this.processIncomingMessage(msgObj); //统一处理
      await me.createStompClient();
      await this.uploadAttachment(me.currentConversationId); //上传附件
      this.clearAllFiles();
      await sendMessage(me.currentConversationId, {
        content: msgObj,
      });

      // me.remedyMessageLoop();
      // me.loopCheckConversationStatus();
    },
    async createStompClient() {
      const me = this;
      if (me.stompClient) {
        return Promise.resolve(me.stompClient);
      }
      let handleResolve, handleReject;
      const promise = new Promise((resolve, reject) => {
        handleResolve = resolve;
        handleReject = reject;
      });
      const stompClient = webSocketClient("/ws/shadow_websocket");
      const destination = "/user/topic/shadow_websocket";
      const headers = {
        "cereb-websocket-id": me.websocketId,
        "cereb-websocket-path": `/${me.currentConversationId}`,
        "access-token": localStorage.token,
      };

      stompClient.connect(
        headers,
        () => {
          handleResolve(stompClient);
          stompClient.subscribe(destination, function (response) {
            const websocketDataVo = JSON.parse(response.body);
            const messageObject = JSON.parse(websocketDataVo.content);
            me.handleMessage(messageObject);
          });
        },
        () => {
          // 连接失败，启动补救机制
          handleReject();
          // me.remedyMessageLoop();
        }
      );
      me.stompClient = stompClient;
      return promise;
    },
    delay(time) {
      return new Promise((resolve) => {
        setTimeout(resolve, time);
      });
    },
    async handleFunctionEnd(data) {
      const functionResult = data.event.functionResult;
      if (
        data.event.functionName === "create_rulego_workflow" &&
        functionResult.success
      ) {
        this.$router.push({
          path: `/ruleflow/${functionResult.response.ruleChain.id}`,
        });
      }
    },
    /**
     * 循环检查对话状态
     */
    loopCheckConversationStatus() {
      const me = this;
      // 递归轮询，确保上一个请求完成后再发起下一个
      const pollStatus = async () => {
        if (!me.currentConversationId) return;
        try {
          const result = await getConversationStatus(me.currentConversationId);
          if (result.status == "Agent is ready") {
            me.sending = false;
            return;
          }
        } catch (e) {
          me.checkConversationTimerTimes++;
          if (me.checkConversationTimerTimes > 5) {
            me.sending = false;
            me.checkConversationTimerTimes = 0;
            return;
          }
        }
        await me.delay(1000 * 30);
        pollStatus();
      };
      pollStatus();
    },
    /**
     * 处理消息
     * @param data 消息数据服务端
     * @param currentMessageItem 当前消息客户端
     */
    async handleMessage(data) {
      const me = this;
      window.clearTimeout(me.receiveMessageTimer);
      console.log("handleMessage", data);
      if (typeof data?.event == "object") {
        // 保存 event 消消息到状态，补 timestamp
        me.agentEvent = {
          ...data.event,
          timestamp: data.timestamp || Date.now(),
          conversationId: data.conversationId,
          websocketId: data.websocketId,
        };
        switch (data.event.type) {
          case "function_start":
            {
              if (data.event.functionName === "start_workflow") {
                me.sending = true;
                me.isWorkflow = true;
              }
            }
            break;
          case "function_end":
            {
              if (data.event.functionName === "start_workflow") {
                me.isWorkflow = false;
              } else {
                me.handleFunctionEnd(data);
              }
            }
            break;
          case 'reply-reallyend': //switch 贯穿
          case "reply-end":
            {
              me.sending = false;
            }
            break;
        }
      } else {
        me.processIncomingMessage(data);
      }

      me.$emit("scroll-to-bottom");
    },
    getLastBubble() {
      return this.bubbleList.length > 0
        ? this.bubbleList[this.bubbleList.length - 1]
        : null;
    },
    async loadHistories() {
      const me = this;
      if (
        me.currentConversationId == null ||
        me.currentConversationId === undefined
      )
        return;
      const getMessageResponse = await getMessageHistory(
        me.currentConversationId,
        0
      );
      console.log("loadHistories", getMessageResponse);
      const { messages } = getMessageResponse;
      me.bubbleList = []; // 清空气泡
      if (messages?.length > 0) {
        for (const msg of messages) {
          me.processIncomingMessage(msg);
        }
        // 滚动到底部
        me.$nextTick(() => {
          me.$emit("scroll-to-bottom");
        });
      }
    },
    /*添加消息到气泡*/
    addMessage(msg) {
      // 构造 MessageModel
      const sourceType =
        msg.source == "User" ? MessageSourceType.USER : MessageSourceType.AI;
      const timestamp = msg.timestamp || Date.now();
      let messageModel;
      if (msg instanceof MessageModel) {
        messageModel = msg;
      } else {
        messageModel = new MessageModel({
          ...msg,
          sourceType,
          timestamp,
        });
      }
      // 合并气泡逻辑：AI 连续消息合并，用户消息单独气泡
      const lastBubble = this.getLastBubble();
      if (
        lastBubble &&
        lastBubble.sourceType === sourceType &&
        sourceType === MessageSourceType.AI
      ) {
        // AI 连续消息合并到同一个气泡
        lastBubble.messageList.push(messageModel);
        this.$emit("scroll-to-bottom");
        return messageModel;
      } else {
        // 新建气泡
        const avatarUrl =
          sourceType === MessageSourceType.USER
            ? defaultUserAvatar
            : this.agentInfo?.avatar_url || defaultBotAvatar;
        const bubble = new BubbleMessage({
          sourceType,
          timestamp,
          avatarUrl,
        });
        bubble.messageList.push(messageModel);
        this.bubbleList.push(bubble);
        this.$emit("scroll-to-bottom");
        return messageModel;
      }
    },
    async sendMessage() {
      const me = this;

      if (me.inputValue === "" && me.fileList.length === 0) {
        return;
      }

      if (me.sending === true) {
        return;
      }

      me.sending = true;

      const tempInput = me.inputValue;
      // 置空
      me.inputValue = "";

      // 尝试一次初始化, 失败则忽略此次发送消息
      if (!me.conversation) {
        await me.initConversation();
      }

      // me.onSendMessage(tempInput);
      await me.handleSendMessage(tempInput);
    },
    /**
     * 初始化方法
     * @param {string} agentId
     * @param {string} conversationId
     */
    async initializeAI({ agentId, conversationId, promptPara = {} }) {
      const me = this;
      me.promptPara = promptPara;
      if (conversationId) {
        // 已有会话，直接赋值
        me.conversation = { conversationId };
        // 可根据实际情况补充 websocketId 等其它字段
      }
      if (agentId) {
        const agentInfo = await this.$store.dispatch(
          "agentStore/fetchAgentById",
          agentId
        );
        me.agentInfo = agentInfo;
        console.log("agentId", agentInfo);
        // 没有会话，初始化新会话
        me._agentId = agentId;
      }
    },
    destroyAI() {
      const me = this;
      me.messageList.splice(0, me.messageList.length);
      me.bubbleList.splice(0, me.bubbleList.length);
      me.clearTimer();
      if (me.stompClient) {
        me.stompClient.disconnect();
      }
      me.conversation = null;
      me.$emit("destroyed");
    },
    exportChatHistory() {
      console.log("exportChatHistory");

      let text = "";
      for (const bubble of this.bubbleList) {
        for (const msg of bubble.messageList) {
          let lines = [];
          lines.push(
            bubble.sourceType === MessageSourceType.USER ? "[User]" : "[AI]"
          );
          lines.push(formatTime(bubble.timestamp));
          let fileNames = [];
          if (Array.isArray(msg.message) && msg.message.length > 0) {
            fileNames = msg.message.map((f) => f.filename);
          } else if (Array.isArray(msg.files) && msg.files.length > 0) {
            fileNames = msg.files.map((f) => f.name);
          }
          for (const name of fileNames) {
            lines.push(name);
          }
          let textContent = "";
          if (
            msg.message &&
            typeof msg.message.content === "string" &&
            msg.message.content.trim()
          ) {
            textContent = msg.message.content.trim();
          } else if (typeof msg.content === "string" && msg.content.trim()) {
            textContent = msg.content.trim();
          }
          if (textContent) lines.push(textContent);
          text += lines.join("\n") + "\n";
        }
        text += "\n";
      }
      text = text.trim();
      // Create a blob and trigger download
      const blob = new Blob([text], { type: "text/plain" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "chat_history.txt";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    removeFileByIndex(index) {
      this.fileList.splice(index, 1);
    },
    addFile(item) {
      this.fileList.push(item);
    },
    clearAllFiles() {
      this.fileList.splice(0, this.fileList.length);
    },
  },
};
